export default __webpack_public_path__ + "static/media/job-tracker.05a9200b.jpg";